<section class="relative flex flex-col items-center w-full">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2">
    <div class="flex items-start justify-between gap-4 flex-wrap">
      <div>
        <h1 class="font-display text-2xl md:text-3xl font-bold text-gray-900">Espace Expert-Comptable</h1>
        <p class="text-gray-500 mt-1">Gérez vos clients, renseignez les identifiants Impots.gouv et obtenez l'avis CFE dès le lendemain.</p>
      </div>
      <div class="flex gap-2 flex-wrap">
        <!--
        <button
          type="button"
          class="rounded-md bg-secondary text-white px-3 py-2 text-sm cursor-pointer hover:bg-secondary-hover"
          (click)="toggleInvitePanel()"
        >
          Inviter un client
        </button>
         -->
        <button
          type="button"
          class="rounded-md bg-secondary text-white border border-gray-300 px-3 py-2 text-sm"
          [class.cursor-pointer]="!atCompanyLimit()"
          [class.hover:bg-secondary-hover]="!atCompanyLimit()"
          [class.opacity-60]="atCompanyLimit()"
          [class.cursor-not-allowed]="atCompanyLimit()"
          (click)="openBulkImportModal()"
        >
          Import de fichier
        </button>

        <!--
        <button
          type="button"
          class="rounded-md border border-gray-300 px-3 py-2 text-sm cursor-pointer hover:bg-gray-50 disabled:opacity-60"
          [disabled]="downloading() || companies().length === 0"
          (click)="handleBulkDownload()"
        >
          @if (downloading()) { Export... } @else { Export CSV }
        </button>
        -->
      </div>
    </div>

    @if (showInvitePanel()) {
      <div class="rounded-2xl bg-white border border-gray-200 p-5 shadow-card space-y-3">
        <h2 class="font-display text-lg font-semibold text-gray-900">Inviter un client</h2>
        <p class="text-sm text-gray-500">Envoyez un email d'invitation a votre client.</p>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
          <input
            type="email"
            class="h-11 rounded-md border border-gray-300 px-3"
            placeholder="client@entreprise.fr"
            [value]="inviteEmail()"
            (input)="inviteEmail.set($any($event.target).value)"
          />
          <input
            type="text"
            class="h-11 rounded-md border border-gray-300 px-3"
            placeholder="Nom entreprise (optionnel)"
            [value]="inviteName()"
            (input)="inviteName.set($any($event.target).value)"
          />
          <input
            type="text"
            class="h-11 rounded-md border border-gray-300 px-3 font-mono tracking-wider"
            placeholder="SIREN/SIRET (optionnel)"
            [value]="inviteSiren()"
            (input)="inviteSiren.set($any($event.target).value)"
          />
        </div>
        <div class="flex justify-end gap-2">
          <button
            type="button"
            class="rounded-md border border-gray-300 px-3 py-2 text-sm cursor-pointer hover:bg-gray-50"
            (click)="toggleInvitePanel()"
          >
            Annuler
          </button>
          <button
            type="button"
            class="rounded-md bg-secondary text-white px-3 py-2 text-sm cursor-pointer hover:bg-secondary-hover"
            (click)="inviteClient()"
          >
            Envoyer l'invitation
          </button>
        </div>
      </div>
    }

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <article class="rounded-2xl bg-white border border-gray-200 p-5 shadow-card">
        <p class="text-xs text-gray-500">Clients</p>
        <p class="text-2xl font-display font-bold text-gray-900 mt-1">{{ totalClients() }}</p>
      </article>
      <article class="rounded-2xl bg-white border border-gray-200 p-5 shadow-card">
        <p class="text-xs text-gray-500">Attestations trouvées</p>
        <p class="text-2xl font-display font-bold text-gray-900 mt-1">—</p>
      </article>
      <article class="rounded-2xl bg-white border border-gray-200 p-5 shadow-card">
        <p class="text-xs text-gray-500">Votre plan</p>
        <p class="text-2xl font-display font-bold text-gray-900 mt-1">CFE</p>
      </article>
    </div>

    <!-- Portail client (désactivé)
    <div class="rounded-xl border border-gray-200 bg-white p-1 inline-flex gap-1 w-fit">
      <button type="button" class="px-3 py-1.5 rounded-md text-sm cursor-pointer" [class.bg-secondary]="activeTab() === 'clients'" [class.text-white]="activeTab() === 'clients'" (click)="activeTab.set('clients')">Mes clients</button>
      <button type="button" class="px-3 py-1.5 rounded-md text-sm cursor-pointer" [class.bg-secondary]="activeTab() === 'portal'" [class.text-white]="activeTab() === 'portal'" (click)="activeTab.set('portal')">Portail client</button>
    </div>
    -->

    @if (activeTab() === 'clients') {
      <div class="rounded-2xl bg-white border border-gray-200 p-6 shadow-card">
        <h2 class="font-display text-lg font-semibold text-gray-900 mb-4">Ajouter un client</h2>
        @if (atCompanyLimit()) {
          <p class="text-sm text-amber-700 mb-3">Limite de {{ maxCompanies }} entreprises atteinte.</p>
        }
        <div class="relative">
          <input
            type="text"
            class="h-11 w-full rounded-md border border-gray-300 px-3 pr-10"
            placeholder="Raison sociale, SIREN ou SIRET"
            [value]="addQuery()"
            (input)="onAddQueryInput($any($event.target).value)"
          />
          <div class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
            @if (addSearching()) {
              <span class="material-symbols-outlined animate-spin text-[18px]">progress_activity</span>
            } @else {
              <span class="material-symbols-outlined text-[18px]">search</span>
            }
          </div>
          @if (showAddSuggestions()) {
            <div
              class="absolute z-40 mt-1 w-full rounded-xl bg-white border border-gray-200 shadow-xl max-h-72 overflow-y-auto"
            >
              @for (suggestion of addSuggestions(); track $index) {
                <button
                  type="button"
                  (click)="selectAddSuggestion(suggestion)"
                  class="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0"
                >
                  <div class="text-sm font-medium text-gray-900 truncate">{{ suggestion.companyName || 'Entreprise' }}</div>
                  <div class="text-[11px] text-gray-500">
                    SIREN {{ suggestion.siren || '—' }} · {{ suggestion.city || '—' }}
                  </div>
                </button>
              } @empty {
                <div class="p-4 text-sm text-center text-gray-500">Aucune entreprise trouvée</div>
              }
            </div>
          }
        </div>

        @if (selectedAddSuggestion(); as sel) {
          <div class="mt-4 rounded-xl border border-gray-200 p-4 space-y-4">
            <div class="flex items-start justify-between gap-4 flex-wrap">
            <div>
              <div class="font-medium text-sm text-gray-900">{{ sel.companyName || sel.siren }}</div>
              <div class="text-xs text-gray-500">SIRET : {{ sel.siret }}</div>
            </div>
            <button
              type="button"
              class="rounded-md bg-secondary text-white px-3 py-2 text-sm cursor-pointer disabled:opacity-60"
              [disabled]="atCompanyLimit() || addingClient()"
              (click)="addClient()"
            >
              @if (addingClient()) { Ajout… } @else { Ajouter }
            </button>
            </div>
            <div class="rounded-lg border border-dashed border-gray-200 bg-gray-50/80 p-4 space-y-3">
              <p class="text-sm font-medium text-gray-800">Identifiants Impots.gouv <span class="font-normal text-gray-500">(optionnel)</span></p>
              <p class="text-xs text-gray-500">
                Renseignez-les maintenant pour obtenir l’avis CFE à partir du lendemain.
              </p>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <label class="flex flex-col gap-1">
                  <span class="text-xs text-gray-500">Utilisateur</span>
                  <input
                    type="text"
                    class="h-9 rounded-md border border-gray-300 px-2 text-sm"
                    placeholder="Identifiant Impots.gouv"
                    [value]="addImpotsNom()"
                    (input)="addImpotsNom.set($any($event.target).value)"
                  />
                </label>
                <label class="flex flex-col gap-1">
                  <span class="text-xs text-gray-500">Mot de passe</span>
                  <input
                    type="password"
                    class="h-9 rounded-md border border-gray-300 px-2 text-sm"
                    placeholder="Mot de passe Impots.gouv"
                    autocomplete="new-password"
                    [value]="addImpotsPass()"
                    (input)="addImpotsPass.set($any($event.target).value)"
                  />
                </label>
              </div>
            </div>
          </div>
        }
      </div>

      <div>
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
          <h2 class="font-display text-lg font-semibold text-gray-900">Mes clients ({{ totalClients() }})</h2>
          <div class="flex flex-col sm:flex-row gap-2 sm:items-center">
            <input
              type="text"
              class="h-10 w-full sm:w-64 rounded-md border border-gray-300 px-3 text-sm"
              placeholder="Filtrer : raison sociale, SIREN, SIRET…"
              [value]="listSearchInput()"
              (input)="onListSearchInput($any($event.target).value)"
            />
            <button
              type="button"
              class="h-10 whitespace-nowrap rounded-md border border-gray-300 bg-white px-3 text-sm cursor-pointer hover:bg-gray-50 disabled:opacity-60"
              [disabled]="downloadingCfeZip() || totalClients() === 0"
              (click)="downloadAllCfeZip()"
            >
              @if (downloadingCfeZip()) {
                Téléchargement…
              } @else {
                Télécharger tous les CFE (ZIP)
              }
            </button>
          </div>
        </div>

        @if (loading()) {
          <div class="rounded-xl border border-gray-200 bg-white p-8 text-center text-gray-500">Chargement...</div>
        } @else if (companies().length === 0 && totalClients() === 0) {
          <div class="rounded-2xl bg-white border border-gray-200 shadow-card p-12 flex flex-col items-center text-center">
            <h3 class="font-display text-lg font-semibold text-gray-900 mb-2">Aucun client pour le moment</h3>
            <p class="text-sm text-gray-500 max-w-sm">Ajoutez vos clients via la recherche ci-dessus.</p>
          </div>
        } @else if (companies().length === 0) {
          <div class="rounded-xl border border-gray-200 bg-white p-8 text-center text-gray-500 text-sm">
            Aucun résultat pour ce filtre. <button type="button" class="text-secondary underline" (click)="listSearchInput.set(''); listPage.set(0); refreshClientsPaged()">Réinitialiser</button>
          </div>
        } @else {
          <div class="rounded-2xl bg-white border border-gray-200 shadow-card overflow-hidden">
            <table class="w-full text-sm">
              <thead class="bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">
                <tr>
                  <th class="w-10 px-3 py-3"></th>
                  <th class="px-3 py-3">Client</th>
                  <th class="px-3 py-3 w-36">SIREN</th>
                  <th class="w-24 px-2 py-3 text-center" title="État global">État</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                @for (company of companies(); track company.siret) {
                  <tr class="hover:bg-gray-50/80 cursor-pointer" (click)="toggleRow(company.siret)">
                    <td class="px-2 py-3 align-top">
                      <button
                        type="button"
                        class="h-8 w-8 flex items-center justify-center rounded-md text-gray-500 cursor-pointer"
                        [attr.aria-expanded]="isExpanded(company.siret)"
                        aria-label="Détail client"
                      >
                        <span class="material-symbols-outlined text-[20px]">{{
                          isExpanded(company.siret) ? 'expand_more' : 'chevron_right'
                        }}</span>
                      </button>
                    </td>
                    <td class="px-3 py-3">
                      <div class="font-medium text-gray-900">{{ company.nomEntreprise || company.siret }}</div>
                      <div class="text-xs text-gray-500">SIRET {{ company.siret }}</div>
                    </td>
                    <td class="px-3 py-3 font-mono text-xs text-gray-700">{{ company.siret.substring(0, 9) }}</td>
                    <td class="px-2 py-3 align-top text-center" (click)="$event.stopPropagation()">
                      @let globalSt = overallStatus(rowDetails()[company.siret]);
                      @if (globalSt; as st) {
                        <span
                          class="material-symbols-outlined text-[22px] inline-block"
                          [class]="statusIconClass(st)"
                          [attr.title]="overallStatusTitle(st)"
                        >{{ statusIcon(st) }}</span>
                        } @else {
                        <span
                          class="material-symbols-outlined text-[22px] text-gray-300 animate-spin inline-block"
                          title="Chargement du statut…"
                        >progress_activity</span>
                      }
                    </td>
              </tr>
              @if (isExpanded(company.siret)) {
                    <tr class="bg-gray-50/90">
                      <td colspan="4" class="px-4 py-4">
                        @if (rowDetailLoading()[company.siret]) {
                          <p class="text-sm text-gray-500">Chargement du détail…</p>
                        } @else if (rowDetails()[company.siret]; as detail) {
                          <div class="space-y-4">
                          <div class="rounded-lg border border-gray-200 bg-white p-4 space-y-3">
                            <div>
                              <h3 class="font-semibold text-gray-900 text-sm">Contact client</h3>
                              <p class="text-xs text-gray-500 mt-0.5">
                                Utilisé pour l’envoi des QR codes Wallet. Les deux champs sont optionnels.
                              </p>
                            </div>
                            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                              <label class="flex flex-col gap-1">
                                <span class="text-xs text-gray-500">Nom du contact</span>
                                <input
                                  type="text"
                                  class="h-9 rounded-md border border-gray-300 px-2 text-sm"
                                  [value]="rowContactDraft()[company.siret]?.name ?? ''"
                                  (input)="updateContactDraft(company.siret, 'name', $any($event.target).value)"
                                  (click)="$event.stopPropagation()"
                                />
                              </label>
                              <label class="flex flex-col gap-1">
                                <span class="text-xs text-gray-500">Email du contact</span>
                                <input
                                  type="email"
                                  class="h-9 rounded-md border border-gray-300 px-2 text-sm"
                                  [value]="rowContactDraft()[company.siret]?.mail ?? ''"
                                  (input)="updateContactDraft(company.siret, 'mail', $any($event.target).value)"
                                  (click)="$event.stopPropagation()"
                                />
                              </label>
                            </div>
                            <button
                              type="button"
                              class="rounded-md bg-secondary px-4 py-2 text-sm text-white cursor-pointer hover:bg-secondary-hover disabled:opacity-50"
                              [disabled]="rowContactSaving()[company.siret]"
                              (click)="saveRowContact(company.siret); $event.stopPropagation()"
                            >
                              @if (rowContactSaving()[company.siret]) {
                                Enregistrement…
                              } @else {
                                Enregistrer le contact
                              }
                            </button>
                          </div>
                          <div class="grid gap-4 md:grid-cols-2">
                            <div class="space-y-2 text-sm">
                              <h3 class="font-semibold text-gray-900">État</h3>
                              <ul class="space-y-2">
                                @let impotsSt = impotsStatus(detail);
                                <li class="flex items-start gap-2" [class]="statusRowClass(impotsSt)">
                                  <span class="material-symbols-outlined text-[18px] shrink-0" [class]="statusIconClass(impotsSt)">{{
                                    statusIcon(impotsSt)
                                  }}</span>
                                  <span>Liaison Impots.gouv (identifiant + mot de passe enregistrés)</span>
                                </li>
                                @let cfeSt = cfeStatus(detail);
                                <li class="flex items-start gap-2" [class]="statusRowClass(cfeSt)">
                                  <span class="material-symbols-outlined text-[18px] shrink-0" [class]="statusIconClass(cfeSt)">{{
                                    statusIcon(cfeSt)
                                  }}</span>
                                  <span>
                                    Avis CFE récupéré
                                    @if (cfeSt === 'pending') {
                                      <span class="block text-xs text-orange-600 mt-0.5">Votre avis CFE sera disponible dès demain</span>
                                    }
                                  </span>
                                </li>
                                <!--
                                @let fiscalSt = fiscalStatus(detail);
                                <li class="flex items-start gap-2" [class]="statusRowClass(fiscalSt)">
                                  <span class="material-symbols-outlined text-[18px] shrink-0" [class]="statusIconClass(fiscalSt)">{{
                                    statusIcon(fiscalSt)
                                  }}</span>
                                  <span>
                                    Informations fiscales récupérées
                                    @if (fiscalSt === 'pending') {
                                      <span class="block text-xs text-orange-600 mt-0.5">Vos informations fiscales seront disponibles dès demain</span>
                                    }
                                  </span>
                                </li>
                                -->
                              </ul>
                              <div class="flex gap-2 items-center mt-3">
                                <button
                                  type="button"
                                  class="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs text-gray-800 hover:bg-gray-50 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                                  [disabled]="!detail.cfeRetrieved || !detail.cfeDocumentId || rowCfeDownloading()[company.siret]"
                                  (click)="downloadClientCfe(company.siret, company.nomEntreprise)"
                                >
                                  <span class="material-symbols-outlined text-[16px]">download</span>
                                  @if (rowCfeDownloading()[company.siret]) {
                                    Téléchargement…
                                  } @else {
                                    Télécharger l’avis CFE
                                  }
                                </button>
                                <button
                                  type="button"
                                  class="inline-flex items-center gap-1 rounded-md border border-red-200 bg-white px-3 py-1.5 text-xs text-red-700 hover:bg-red-50 cursor-pointer"
                                  (click)="removeClient(company)"
                                >
                                  <span class="material-symbols-outlined text-[16px]">delete</span>
                                  Retirer ce client
                                </button>
                              </div>
                            </div>
                            <div class="space-y-3 rounded-lg border border-gray-200 bg-white p-4">
                              <h3 class="font-semibold text-gray-900 text-sm">Identifiants Impots.gouv</h3>
                              <label class="block text-xs text-gray-500">Utilisateur</label>
                              <input
                                type="text"
                                class="h-9 w-full rounded-md border border-gray-300 px-2 text-sm"
                                [value]="rowPasswordDraft()[company.siret]?.nom ?? ''"
                                (input)="updateRowDraft(company.siret, 'nom', $any($event.target).value)"
                              />
                              <label class="block text-xs text-gray-500">Mot de passe</label>
                              <div class="flex gap-2">
                                <input
                                  [type]="rowPasswordPlainVisible()[company.siret] ? 'text' : 'password'"
                                  class="h-9 flex-1 min-w-0 rounded-md border border-gray-300 px-2 text-sm font-mono"
                                  autocomplete="new-password"
                                  [value]="passwordInputValue(company.siret)"
                                  [readonly]="showsStoredPasswordPlaceholder(company.siret)"
                                  (focus)="onPasswordFocus(company.siret)"
                                  (input)="updateRowDraft(company.siret, 'pass', $any($event.target).value)"
                                />
                                @if (detail.impotsPasswordStored) {
                                  <button
                                    type="button"
                                    class="h-9 shrink-0 rounded-md border border-gray-300 px-2 text-xs cursor-pointer hover:bg-gray-50 disabled:opacity-50"
                                    [disabled]="rowRevealing()[company.siret]"
                                    (click)="revealPassword(company.siret)"
                                  >
                                    @if (rowRevealing()[company.siret]) {
                                      …
                                    } @else {
                                      Révéler
                                    }
                                  </button>
                                }
                              </div>
                              <p class="text-[11px] text-gray-400">
                                @if (detail.impotsPasswordStored) {
                                  Un mot de passe est enregistré (affiché sous forme masquée). Cliquez sur « Révéler » pour l’afficher, ou saisissez-en un nouveau.
                                } @else {
                                  Saisissez le mot de passe Impots.gouv du client.
                                }
                              </p>
                              <button
                                type="button"
                                class="rounded-md bg-secondary px-4 py-2 text-sm text-white cursor-pointer hover:bg-secondary-hover disabled:opacity-50"
                                [disabled]="rowSaving()[company.siret]"
                                (click)="saveRowPasswords(company.siret)"
                              >
                                @if (rowSaving()[company.siret]) {
                                  Enregistrement…
                                } @else {
                                  Enregistrer les identifiants
                                }
                              </button>
                            </div>
                          </div>
                          </div>
                        }
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
          @if (listTotalPages() > 1) {
            <div class="mt-4 flex items-center justify-center gap-4 text-sm text-gray-600">
              <button
                type="button"
                class="rounded-md border border-gray-300 px-3 py-1.5 cursor-pointer hover:bg-gray-50 disabled:opacity-40"
                [disabled]="listPage() <= 0"
                (click)="goPrevPage()"
              >
                Précédent
              </button>
              <span>Page {{ listPage() + 1 }} / {{ listTotalPages() }}</span>
              <button
                type="button"
                class="rounded-md border border-gray-300 px-3 py-1.5 cursor-pointer hover:bg-gray-50 disabled:opacity-40"
                [disabled]="listPage() >= listTotalPages() - 1"
                (click)="goNextPage()"
              >
                Suivant
              </button>
            </div>
          }
        }
      </div>
    }

    <!-- @if (activeTab() === 'portal') {
      <app-expert-portal></app-expert-portal>
    } -->
  </div>
</section>
